// Firebase Configuration
// Replace these values with your Firebase project credentials
// Get them from: https://console.firebase.google.com/

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your Firebase configuration object
// Values from environment variables (.env file) or fallback to defaults
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC69QtCKHywzjEpR5OaBex1yb9j-TixGKY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "kdgeneraltransport.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "kdgeneraltransport",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "kdgeneraltransport.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "673185212672",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:673185212672:web:cc8a244d32c3b7f5f3abe5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database
export const db = getFirestore(app);

// Initialize Firebase Auth (for future use)
export const auth = getAuth(app);

export default app;

